export const MOBILE_DASHBOARD_MOBILE_FLOW_ANALYZER_CONTENT_DAID = 'mobile-flow-analyzer-content';
export const MOBILE_DASHBOARD_MOBILE_SDKS_CONTENT_DAID = 'mobile-sdks-content';
